import { createContext, useContext } from 'react';

export interface CollapsibleContentCardContext {
  isCollapsed: boolean;
  toggleCollapse: () => void;
}

export const CardContext = createContext<CollapsibleContentCardContext | undefined>(undefined);

export const useCardContext = () => {
  const context = useContext(CardContext);
  if (!context) {
    throw new Error('Card components must be used within CollapsibleContentCard');
  }
  return context;
};
